import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import BlogList from './pages/BlogList';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ClientPortal from './pages/ClientPortal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CloudArchitecture from './pages/services/CloudArchitecture';
import DevOpsAutomation from './pages/services/DevOpsAutomation';
import KubernetesManagement from './pages/services/KubernetesManagement';
import SecurityCompliance from './pages/services/SecurityCompliance';
import FinOpsCostOptimization from './pages/services/FinOpsCostOptimization';
import MonitoringObservability from './pages/services/MonitoringObservability';

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/change-password" element={<ChangePassword />} />
        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />
        <Route path="/client-portal" element={<ClientPortal />} />
        <Route path="/client-portal/:accessKey" element={<ClientPortal />} />
        <Route path="/services/cloud-architecture" element={<CloudArchitecture />} />
        <Route path="/services/devops-automation" element={<DevOpsAutomation />} />
        <Route path="/services/kubernetes-management" element={<KubernetesManagement />} />
        <Route path="/services/security-compliance" element={<SecurityCompliance />} />
        <Route path="/services/finops-cost-optimization" element={<FinOpsCostOptimization />} />
        <Route path="/services/monitoring-observability" element={<MonitoringObservability />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/* Catch-all route for client portal access keys (must be last) */}
        <Route path="/:accessKey" element={<ClientPortal />} />
      </Routes>
    </BrowserRouter>
  );
}
